import React from 'react';
import style from './SectionHeading.module.css';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  className?: string;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  icon,
  className,
}) => (
  <div className={`${style.sectionHeader}${className ? ` ${className}` : ''}`}>
    {icon && <span className={style.sectionIcon}>{icon}</span>}
    <div className={style.titleText}>
      <h6>{title}</h6>
      {subtitle && <p className={style.subtitle}>{subtitle}</p>}
    </div>
  </div>
);

export const PersonIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 2.5c-4.34 0-7.5 2.46-7.5 5.5v.5a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V20c0-3.04-3.16-5.5-7.5-5.5z" />
  </svg>
);

export const StarIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01L12 2z" />
  </svg>
);

export default SectionHeading;
